import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/**
 * Created by haocongxu on 2017/12/16.
 */

export default function (storagekey) {
  var _key = "coa_fallback_".concat(storagekey);
  var _fallbackData = localStorage && localStorage.getItem(_key);
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var fallbackData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return next();
            case 3:
              localStorage && localStorage.setItem(_key, JSON.stringify(this.response));
              return _context.abrupt("return");
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log("%c coa-middleware %c Fallback: 尝试获取" + storagekey + "缓存数据 ", "background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;", "background:#196CFB; padding: 1px; border-radius: 0 3px 3px 0; color: #fff;");
              if (_fallbackData) {
                _context.next = 15;
                break;
              }
              console.log("%c coa-middleware %c Fallback: 暂无" + storagekey + "缓存数据 ", "background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;", "background:#196CFB; padding: 1px; border-radius: 0 3px 3px 0; color: #fff;");
              throw _context.t0;
            case 15:
              console.log("%c coa-middleware %c Fallback: 解析" + storagekey + "缓存数据 ", "background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;", "background:#196CFB; padding: 1px; border-radius: 0 3px 3px 0; color: #fff;");
              fallbackData = JSON.parse(_fallbackData);
              fallbackData['__coa_fallback_data__'] = 1;
              this.response = fallbackData;
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}